// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3AMwi","content":"GlobalSearch_content__cT9e9"};